module.exports = __webpack_public_path__ + "static/img/it3_en.7a88242.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/it3_en.png
// module id = VuXu
// module chunks = 0